// components/Innovation/InnovationIntroCards.tsx
const cards = [
  "YESOAIR introduces a breakthrough in personalized medical care, combining deep expertise in 3D technology with orthopedic innovation.",
  "Bespoke meets personalization through patient-specific 3D medical binding solutions powered by advanced scanning software.",
  "Patented technology and clinical insight come together to redefine healing and shape the future of healthcare.",
];

const InnovationIntroCards = () => {
  return (
    <section className="bg-white">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
        {cards.map((text, index) => (
          <div
            key={index}
            className="border border-primary/40 rounded-2xl p-6 bg-[#F6F7F7] text-center  transition"
          >
            <p className="text-text-secondary leading-relaxed max-w-md mx-auto">
              {text}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default InnovationIntroCards;
